/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './regimen-checklist-item.reducer';

export const RegimenChecklistItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const regimenChecklistItemEntity = useAppSelector(state => state.regimenChecklistItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="regimenChecklistItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.regimenChecklistItem.detail.title">RegimenChecklistItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.regimenChecklistItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{regimenChecklistItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.regimenChecklistItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{regimenChecklistItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.regimenChecklistItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{regimenChecklistItemEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.regimenChecklistItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{regimenChecklistItemEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.regimenChecklistItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{regimenChecklistItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.regimenChecklistItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{regimenChecklistItemEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenChecklistItem.item">Item</Translate>
          </dt>
          <dd>{regimenChecklistItemEntity.item ? regimenChecklistItemEntity.item.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenChecklistItem.regimen">Regimen</Translate>
          </dt>
          <dd>{regimenChecklistItemEntity.regimen ? regimenChecklistItemEntity.regimen.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/regimen-checklist-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/regimen-checklist-item/${regimenChecklistItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RegimenChecklistItemDetail;
